import React from "react";
import PropTypes from "prop-types";

// components
export default function CardSwids({ color, token }) {

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-blue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-gray-800" : "text-white")
                }
              >
                Software Numbers
              </h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  ECU Name
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Hardware Id
                </th>                
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Software Id
                </th>
              </tr>
            </thead>
            <tbody>
            {token!=null && token.map((item,index) => {
                return (
                  <tr key={index} className={((index%2) === 0
                  ? "bg-blue-100 text-blue-300 border-blue-200"
                  : "bg-blue-800 text-blue-300 border-blue-700")}>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-3 text-left">                      
                      <span
                        className={
                          "ml-3 font-bold " +
                          +(color === "light" ? "text-gray-700" : "text-white")
                        }
                      >
                        {item["cuDesignation"]}
                      </span>
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-3 text-left">                      
                      <span
                        className={
                          "ml-3 font-bold " +
                          +(color === "light" ? "text-gray-700" : "text-white")
                        }
                      >
                        {typeof item["activeState"] !== 'undefined' ? item["activeState"]["objectNumber"] : ""}
                      </span>
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-3 items-center">
                      {typeof item["activeState"] !== 'undefined' && item["activeState"]["installedSoftware"].map((subitem,subindex) => {
                        return (
                          <span className="text-sm block">{subitem["objectNumber"]}</span>
                        )                      
                      })}                   
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

CardSwids.defaultProps = {
  color: "light",
};

CardSwids.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
